module.exports = __webpack_public_path__ + "img/cb04ff8f03ac8db84239ad03cbb0846f.png";